import { graphql } from '@apollo/client/react/hoc';

import CreateEventImpressionMutation from 'buyside/graphql/mutations/CreateEventImpression';

import FeedItem from 'buyside/components/presentation/Feed/FeedItem/feedItem';

const FeedItemContainer = graphql(CreateEventImpressionMutation, {
  props: ({ mutate }) => ({
    handleImpression: props => {
      const { eventId, elapsedTime, index, sessionId, source } = props;

      return mutate({
        variables: { eventId, elapsedTime, index, sessionId, source }
      });
    }
  })
})(FeedItem);

export default FeedItemContainer;
